module.exports = __webpack_public_path__ + "static/mutter-02-c3aded2852809b07fa609402942e4e60.jpg";